module.exports = __webpack_public_path__ + "static/media/crown_yellow.77ba6988.PNG";